$(document).on("click", ".js-address_soft_del", function(e){
    e.preventDefault();
    $currentElement = $(this);
    var tmpText = $currentElement.text();
    $currentElement.text($currentElement.data("del_confirm")).removeClass("js-address_soft_del").addClass("js-address_del")
    setTimeout(function(){
        $currentElement.text(tmpText).removeClass("js-address_del").addClass("js-address_soft_del")
    }, 8000)
});

$(document).on("click", ".js-address_del", function(e){
    e.preventDefault();
    $currentElement = $(this);

    $.ajax({
        url:$currentElement.data("root") + "cmshx_template/ajax/account_address_del.php",
        data:{id:$currentElement.data("id"),
              csrf_token:csrf_token
        },
        type:"POST"
    }).done(function(success){
        if(success == 1){
            $currentElement.parents(".js-address_block").fadeOut(300, function(){
                if($(this).siblings(".js-address_block").length == 0){
                    $(this).siblings(".js-address_block_no_address").show();
                }
                $(this).remove();
            });
        }
    })
});